'use client';

import { IMenuProps, Menu } from '@bts-web/core-features/common';
import { useChangeLanguage } from '@bts-web/core-features/language';
import { FC } from 'react';
import { TopBarMenuButton } from '../LayoutWithLeftDesktopNav/DesktopTopHeaderBar/subcomponents/TopBarMenuButton/TopBarMenuButton';
import { LanguageChangeMenu } from '../../language/LanguageChangeMenu/LanguageChangeMenu.use-client';
import { useClientUserInfo } from '../../common/userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';

const dropdownMenuProps: IMenuProps['dropdownMenuProps'] = {
  style: {
    width: '340px',
    maxWidth: `calc(100vw - 40px)`,
    backgroundColor: 'transparent',
    borderRadius: '12px',
  },
  align: 'end',
  sideOffset: 5,
  sticky: 'always',
  updatePositionStrategy: 'always',
};

export type TopBarLanguageTranslations = {
  germanSubtitle: string;
  englishSubtitle: string;
  arabicSubtitle: string;
  frenchSubtitle: string;
  errorTitle: string;
  errorSubtitle: string;
};

const ChangeLanguage: FC<{
  translations: TopBarLanguageTranslations;
  currentLanguageTranslations: string;
}> = ({ translations, currentLanguageTranslations }) => {
  const { onChangeLanguage, isUserUpdateLoading } = useChangeLanguage({
    translations: {
      errorSubtitle: translations.errorSubtitle,
      errorTitle: translations.errorTitle,
    },
  });

  const { language } = useClientUserInfo();

  return (
    <Menu
      dropdownMenuProps={dropdownMenuProps}
      components={{
        buttonElement: (
          <TopBarMenuButton
            isLoading={isUserUpdateLoading}
            data-testid="language-button"
          >
            {currentLanguageTranslations}
          </TopBarMenuButton>
        ),
        menuContent: (
          <LanguageChangeMenu
            isWithinDropdown={true}
            translations={translations}
            onLanguageValueChange={onChangeLanguage}
            currentValue={language}
            isLoading={isUserUpdateLoading}
          />
        ),
      }}
    />
  );
};

export { ChangeLanguage };
